import 'vuetify/styles'  
import { createVuetify } from 'vuetify';
import '@mdi/font/css/materialdesignicons.css';
import * as directives from 'vuetify/directives';
import es from 'vuetify/lib/locale/es';

//DragScroll
import { VueDraggableNext } from 'vue-draggable-next';
import {  THEME } from '@/theme/LightTheme';
import { DARK_THEME } from '@/theme/DarkTheme';
import { VDateInput } from 'vuetify/labs/VDateInput';

export default createVuetify({
    locale: {
        locale: 'es',
        messages: { es }
    },
    components: {
        draggable: VueDraggableNext,
        VDateInput
    },
    directives,

    theme: {
        defaultTheme: 'THEME',
        themes: {
            THEME,
            DARK_THEME,            
        }
    },
    defaults: {
        VCard: {
            rounded: 'xl'
        },
        VTextField: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        VTextarea: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        VSelect: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        VListItem: {
            minHeight: '45px'
        },
        VTooltip: {
            location: 'top'
        }
    }
});
